var _path, _path2;
import * as React from "react";
function SvgUnstar(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.995 2.545c.839 0 1.602.478 1.963 1.228l4.384 9.019 9.797 1.445a2.187 2.187 0 011.752 1.48c.259.784.048 1.65-.539 2.229l-7.103 7.029.212 1.254-17.019-13.407.206-.03 4.384-9.02a2.185 2.185 0 011.963-1.227zM9.595 13.39l-5.737.847c-.818.123-1.5.696-1.752 1.48a2.193 2.193 0 00.539 2.229l7.103 7.029-1.677 9.933a2.188 2.188 0 003.184 2.29l8.747-4.67 8.747 4.67c.736.39 1.63.335 2.304-.156a2.194 2.194 0 00.88-2.134l-.768-4.525L9.595 13.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.933 5.07a1 1 0 011.405-.162l30.524 24.177a1 1 0 01-1.241 1.568L5.096 6.476a1 1 0 01-.163-1.405z",
    fill: "#fff"
  })));
}
export default SvgUnstar;